var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mf-tooltip',{attrs:{"bottom":"","max-width":"300px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',{staticClass:"toolbar-custom-btn mx-2 beamerTrigger"},[_c('mf-icon',{attrs:{"color":"branco","wght":300,"icon":"notifications"}})],1)]}}])},[_c('span',[_vm._v("Novidades")])])}
var staticRenderFns = []

export { render, staticRenderFns }